import styled from 'styled-components';

export const Footer = styled.footer`
  background-color: #333;
  color: white;
  text-align: center;
  padding: 25px 20px;
  font-size: 12px;
  margin-top: 100px;

  @media (max-width: 768px) {
    padding: 20px 15px;
    font-size: 10px; 
  }
`;